export default __webpack_public_path__ + "static/net-cda24dde8b97085d1f8f35871658b701.png";